import React from 'react';
import { useTheme } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import ChartCard from './ChartCard';
import { TrendData } from './types';

interface SalesGrowthChartProps {
  data: TrendData;
}

const SalesGrowthChart: React.FC<SalesGrowthChartProps> = ({ data }) => {
  const theme = useTheme();
  const title = data.useQuarters
    ? 'Quarter-on-Quarter Sales: Food vs Room'
    : 'Month-on-Month Sales: Food vs Room';

  return (
    <ChartCard title={title} timeout={1600}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data.rows} margin={{ top: 8, right: 24, left: 8, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.grey[200]} />
          <XAxis dataKey="period" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary} />
          <RechartsTooltip
            formatter={(value: any, name: any, props: any) => {
              const idx = props?.payload?.payloadIndex ?? 0;
              const row = data.rows[idx];
              const growth = name === 'Food' ? row?.foodGrowthPct : row?.roomGrowthPct;
              const suffix = growth === null || growth === undefined ? '' : ` (Δ ${growth}%)`;
              return [`₹${Number(value).toLocaleString()}${suffix}`, name];
            }}
          />
          <Legend />
          <Bar dataKey="food" name="Food" fill={theme.palette.primary.main} />
          <Bar dataKey="room" name="Room" fill={theme.palette.secondary.main} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default SalesGrowthChart;
